.gamecontrols {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 1.25em;
  margin: 2em 0 3em 0;
}

.reset__btn {
  border: none;
  padding: 0.5em 1em;
  background-color: #4a81b9;
  box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  transition: transform 0.25s;
  cursor: pointer;
}

.reset__btn:hover {
  transform: scale(1.025);
}